<template>
  <div class="blog-detail-wrapper" v-if="item.type === 'short_search'">
    <b-row>
      <!-- blogs -->
      <b-col cols="12">
        <b-card>
          <b-media no-body>
            <b-media-aside vertical-align="center" class="mr-50">
              <b-avatar
                href="javascript:void(0)"
                size="24"
                :src="item.user.profile_image_path"
              />
            </b-media-aside>
            <b-media-body>
              <small class="text-muted mr-50">by</small>
              <small>
                <b-link class="text-body">{{ item.user.full_name }}</b-link>
              </small>
              <span class="text-muted ml-75 mr-50">|</span>
              <small class="text-muted">{{ item.created_at }}</small>
              <h6 class="font-weight-bolder">
                {{ item.name }}
              </h6>
              <b-card-text>
                {{ item.questions[0].question }}
              </b-card-text>
            </b-media-body>
          </b-media>

          <!-- user forum answers -->
        </b-card>
      </b-col>
      <!-- Leave a Blog Comment -->
      <b-col cols="12" class="mt-2" v-if="checkNumber(item) && checkTime(item)">
        <h6 class="section-label">
          {{ $t("activities.upload_your_search") }}
        </h6>
        <b-card>
          <validation-observer ref="registerForm" #default="{ invalid }">
            <b-form>
              <b-row>
                <b-col cols="12">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('activities.short_search')"
                    vid="search_file"
                    rules="required"
                  >
                    <b-form-group class="mb-2">
                      <b-form-file
                        v-model="newAnswer.file"
                        placeholder="اختيار ملف أو تسقطها هنا ..."
                        drop-placeholder="إسقاط الملف هنا ..."
                        accept="application/pdf,.ppt,.pptx,docx"
                        :state="errors.length > 0 ? false : null"
                      />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    :disabled="invalid"
                    variant="primary"
                    @click="submit()"
                  >
                    {{ $t("site.add") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>
      <b-col lg="12" v-for="(answer, index) in search_answers" :key="index">
        <b-card>
          <b-media no-body>
            <b-media-body>
              <h6 class="font-weight-bolder">
                {{ $t("activities.grade") }} :
                <b-badge
                  >{{ (answer.grade * (item.grade / 100)).toFixed(2) }}/{{
                    item.grade
                  }}</b-badge
                >
              </h6>
              <b-button variant="outline-success" :href="answer.file">
                <i class="fa fa-download"></i>
                {{ $t("activities.press_to_download") }}
              </b-button>
            </b-media-body>
          </b-media>
          <comment-vue
            :commentableid="answer.id"
            commentabletype="App\ActivityUserAnswer"
            type="text"
          ></comment-vue>
        </b-card>
      </b-col>
      <!--/ blogs -->
    </b-row>
    <!--/ blogs -->
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import ActivitiesController from "@/Controllers/ActivitiesController";
import Auth from "@/Apis/Auth";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import CommentVue from "./Comment.vue";

export default {
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    CommentVue,
  },
  data() {
    return {
      file: {},
      search_answers: [],
      newAnswer: {},
      user: {},
      load: false,
      totalAnswers: 0,
    };
  },
  directives: {
    Ripple,
  },
  async created() {
    this.load = true;
    this.user = Auth.USER;
    await this.getAnswers();
    this.load = false;
  },
  methods: {
    checkTime(item) {
      const check = new Date();

      const stDate = new Date(item.start_date);
      const enDate = new Date(item.end_date);

      if (
        check.getTime() <= enDate.getTime() &&
        check.getTime() >= stDate.getTime()
      )
        return true;
      // && datanow <= enDate) return true;
      return false;
    },
    checkNumber(item) {
      if (item.unlimited == 1) return true;
      if (this.totalAnswers < 3) return true;
      return false;
    },
    async getAnswers() {
      this.load = true;
      const data = await new ActivitiesController().forum_answers({
        question_id: this.$props.item.questions[0].id,
        user_id: this.user.id,
      });
      this.search_answers = data;
      this.countMyTotalAnswers();
      this.load = false;
    },
    countMyTotalAnswers() {
      this.totalAnswers = this.search_answers.filter((obj) => {
        if (obj.user_id == this.user.id) {
          return true;
        }
        return false;
      }).length;
    },
    async submit() {
      this.dataHandle();
      let ret = await new ActivitiesController().activity_answer(
        this.newAnswer
      );
      if (ret) {
        this.load = true;
        await this.getAnswers();
        this.newAnswer = {};
        this.load = false;
      }
    },
    dataHandle() {
      this.newAnswer.answer_number = this.totalAnswers + 1;
      this.newAnswer.activity_question_id = this.$props.item.questions[0].id;
      this.newAnswer.user_id = this.user.id;
      this.newAnswer.user = this.user;
      this.newAnswer.activity = this.$props.item;
    },
  },
};
</script>
<style>
</style>